import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import Checkbox from '../checkbox';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
const defaultRules = {};

const CheckboxField = ({
  id = '',
  name,
  control,
  rules = defaultRules,
  onChange = noop,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (...args) => {
      field.onChange(...args);
      if (onChange) onChange(...args);
    },
    [field, onChange]
  );

  return (
    <React.Fragment>
      <Checkbox
        {...otherProps}
        id={id || field.name}
        name={field.name}
        value={field.name}
        checked={field.value}
        onChange={handleChange}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

export default CheckboxField;
